import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";

import "./css/site.css";
import i18n from "./i18n";

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    libraries: ["places", "geometry"],
    key: "AIzaSyDJSN1GBFc3_ZCY9x9iPyXZtrXk3DiZj0A"
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
